import { render, staticRenderFns } from "./PruebaModal.vue?vue&type=template&id=b66b01e0"
import script from "./PruebaModal.vue?vue&type=script&lang=js"
export * from "./PruebaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports